module.exports = {
      id: "home-usage",
      viewBox: "0 0 15.417 13.987",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#home",
      toString: function () {
        return this.url;
      }
    }